const resources = {
    giftFinder: 'Explorateur cadeaux',
    newChat: 'Nouvelle conversation'
};

export default function getResource(label) {
    return resources[label];
}
